if(!window.__livinartReviewsBound){
  window.__livinartReviewsBound=true;

  document.addEventListener('DOMContentLoaded',function(){
    var VERIFIED_REVIEW_FLOOR=201;
    var layer=document.querySelector('[data-la-review-layer]');
    var modal=document.querySelector('[data-la-review-modal]');

    function lock(){document.body.classList.add('la-review-lock')}
    function unlock(){
      if(!(layer&&layer.classList.contains('is-open'))&&!(modal&&modal.classList.contains('is-open'))){
        document.body.classList.remove('la-review-lock');
      }
    }
    function openFallbackDrawer(){
      if(!layer)return;
      layer.classList.add('is-open');
      lock();
      var c=layer.querySelector('[data-la-review-close]');
      if(c)c.focus();
    }
    function closeDrawer(){
      if(!layer)return;
      layer.classList.remove('is-open');
      unlock();
    }
    function closeModal(){
      if(!modal)return;
      modal.classList.remove('is-open');
      unlock();
    }

    function findDoranReviewSection(){
      return document.querySelector('[id*="__doran_reviews"], [id*="doran_reviews"], [data-la-review-app-host]');
    }

    function openOfficialDoranReviewForm(btn){
      var target=btn && btn.getAttribute('data-la-review-url');
      if(!target){
        target=window.location.pathname+'#pr_write_review';
      }

      closeDrawer();

      try{
        var absolute=new URL(target,window.location.origin);
        absolute.search='';
        absolute.hash='pr_write_review';
        window.history.replaceState(null,'',absolute.pathname+absolute.hash);
        window.location.reload();
      }catch(err){
        window.location.href=target;
      }
    }

    function configureDoran(){
      var init=window.$prDoranInit;
      if(!init||!init.popupWidget)return false;
      init.popupWidget.isAverageRating=true;
      init.popupWidget.isDisplayShopReviews=true;
      return true;
    }

    function getDoranLauncher(){
      var launchers=document.querySelectorAll('.popup-launcher');
      for(var i=0;i<launchers.length;i++){
        if(!launchers[i].hasAttribute('data-la-review-open'))return launchers[i];
      }
      return null;
    }

    function getBestStoreReviewCount(){
      var best=VERIFIED_REVIEW_FLOOR;
      var init=window.$prDoranInit;

      function inspect(obj,depth){
        if(!obj || depth>4 || typeof obj!=='object') return;
        Object.keys(obj).forEach(function(key){
          var val=obj[key];
          if(/review.*count|count.*review|total.*review|reviewsCount|reviewCount/i.test(key)){
            var n=Number(val);
            if(isFinite(n) && n>=VERIFIED_REVIEW_FLOOR) best=Math.max(best,n);
          }
          if(val && typeof val==='object') inspect(val,depth+1);
        });
      }

      inspect(init,0);

      document.querySelectorAll('body *').forEach(function(el){
        if(el.children.length) return;
        var txt=(el.textContent||'').trim();
        var m=txt.match(/(?:based on\s+)?(\d+)\s+(?:customer\s+)?reviews?\b/i);
        if(m){
          var n=Number(m[1]);
          if(isFinite(n) && n>=VERIFIED_REVIEW_FLOOR) best=Math.max(best,n);
        }
      });

      return best;
    }

    function syncDisplayedReviewCount(){
      var total=getBestStoreReviewCount();

      document.querySelectorAll('[data-la-review-open]').forEach(function(btn){
        btn.setAttribute('data-store-review-count',String(total));
      });

      document.querySelectorAll('body *').forEach(function(el){
        if(el.children.length) return;
        var txt=(el.textContent||'').trim();
        if(!txt) return;

        var patterns=[
          /^(\d+)\s+reviews?$/i,
          /^based on\s+(\d+)\s+reviews?$/i,
          /^(\d+)\s+customer reviews?$/i
        ];

        for(var i=0;i<patterns.length;i++){
          var m=txt.match(patterns[i]);
          if(!m) continue;
          var current=Number(m[1]);
          if(!isFinite(current) || current<100 || current>=total) break;
          el.textContent=txt.replace(m[1],String(total));
          break;
        }
      });
    }

    function syncStoreRating(){
      var init=window.$prDoranInit;
      var average=init&&init.shopAverageRating&&init.shopAverageRating.averageRating;
      if(average!==undefined&&average!==null){
        var value=Number(average);
        if(isFinite(value)){
          document.querySelectorAll('[data-la-review-open]').forEach(function(btn){
            btn.setAttribute('data-store-rating',value.toFixed(1));
            btn.setAttribute('aria-label','Open all customer reviews. Overall rating '+value.toFixed(1)+' out of 5, '+getBestStoreReviewCount()+' reviews');
          });
        }
      }
      syncDisplayedReviewCount();
    }

    function openDoranReviews(event){
      if(event){
        event.preventDefault();
        event.stopPropagation();
      }

      closeDrawer();
      configureDoran();
      syncStoreRating();

      var attempts=0;
      function tryOpen(){
        configureDoran();
        syncStoreRating();

        var launcher=getDoranLauncher();
        if(launcher){
          launcher.click();
          return;
        }

        attempts+=1;
        if(attempts<20){
          window.setTimeout(tryOpen,150);
        }else{
          openFallbackDrawer();
        }
      }
      tryOpen();
    }

    document.querySelectorAll('[data-la-review-open]').forEach(function(btn){
      btn.addEventListener('click',openDoranReviews);
    });

    if(layer){
      var closer=layer.querySelector('[data-la-review-close]');
      var overlay=layer.querySelector('[data-la-review-overlay]');
      if(closer)closer.addEventListener('click',closeDrawer);
      if(overlay)overlay.addEventListener('click',closeDrawer);
    }

    document.querySelectorAll('[data-la-scroll-reviews]').forEach(function(link){
      link.addEventListener('click',function(e){
        var target=findDoranReviewSection();
        if(!target)return;
        e.preventDefault();
        closeDrawer();
        target.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });

    document.querySelectorAll('[data-la-review-write]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        openOfficialDoranReviewForm(btn);
      });
    });

    document.querySelectorAll('[data-la-review-modal-close]').forEach(function(btn){
      btn.addEventListener('click',closeModal);
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){
        closeDrawer();
        closeModal();
      }
    });

    configureDoran();
    syncStoreRating();
    syncDisplayedReviewCount();
    [100,350,800,1600,3000].forEach(function(delay){
      window.setTimeout(function(){
        configureDoran();
        syncStoreRating();
      },delay);
    });

    var observer=new MutationObserver(function(){
      configureDoran();
      syncStoreRating();
      syncDisplayedReviewCount();
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});

    if(modal){
      modal.remove();
    }
  });
}